import { Component, Input } from '@angular/core';
import { _buttonBaseComponent } from '../_button-base/_button-base.component';

@Component({
  selector: 'app-reset-button',
  templateUrl: './reset-button.component.html',
  styleUrls: ['./reset-button.component.css']
})
export class ResetButtonComponent extends _buttonBaseComponent {
  constructor() {
    super();
    this.buttonText = 'General.Reset'
  }
}
